import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ThankYou from "@/pages/ThankYou";
const ThankYouRoute = () => <ThankYou variant="signing-up" />;

export const Route = createFileRoute("/es/gracias/registro")({
  head: () => buildRouteHead("/es/gracias/registro"),
  component: ThankYouRoute,
});

